import { useMemo, useState } from 'react'

export default function useRefresh<T extends Record<string, number>>(initialState: T) {
  const [refresh, setRefresh] = useState(initialState)

  const handleRefresh = (key: keyof T) => {
    setRefresh(prev => ({
      ...prev,
      [key]: prev[key] + 1
    }))
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => [refresh, handleRefresh] as const, [refresh])
}
